<template>
  <div class="text-center" :class="classes">
    <p>{{ title }}</p>
    <!-- Ako hoćeš i podnaslov, otkomentariši:
    <p class="text-muted" v-if="subTitle">{{ subTitle }}</p>
    -->
  </div>
</template>

<script setup>
const props = defineProps({
  title: {
    type: String,
    default: ''
  },
  subTitle: {
    type: String,
    default: ''
  },
  classes: {
    type: String,
    default: ''
  }
})

const { title, subTitle, classes } = props
</script>
